export const SEARCH_KEYWORD_MIN_LENGTH = 3;



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/constants/search.js